import { inject, injectable } from 'inversify';
import IdVerificationRepository from 'src/features/verification/data/IdVerificationRepository';
import { VerificationSession } from 'src/features/verification/data/service/idVerificationService.types';

interface GetIdVerificationSessionUseCaseParams {
  token: string;
}

interface GetIdVerificationSessionUseCaseInterface {
  execute(
    params: GetIdVerificationSessionUseCaseParams
  ): Promise<VerificationSession>;
}

@injectable()
class GetIdVerificationSessionUseCase
  implements GetIdVerificationSessionUseCaseInterface
{
  @inject(IdVerificationRepository)
  private idVerificationRepository!: IdVerificationRepository;

  async execute({
    token,
  }: GetIdVerificationSessionUseCaseParams): Promise<VerificationSession> {
    try {
      const currentSession =
        await this.idVerificationRepository.getSessionStatus({
          accessToken: token,
        });

      if (currentSession) {
        return currentSession;
      } else {
        const sessionData =
          await this.idVerificationRepository.getOrCreateSession({
            accessToken: token,
          });

        return sessionData;
      }
    } catch (error) {
      throw new Error((error as Error).message);
    }
  }
}

export default GetIdVerificationSessionUseCase;
